import { render, staticRenderFns } from "./TrangCapNhatNguoiDung.vue?vue&type=template&id=6208f60b&"
import script from "./TrangCapNhatNguoiDung.vue?vue&type=script&lang=js&"
export * from "./TrangCapNhatNguoiDung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports